import React, { ComponentPropsWithRef } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'
import clsx from 'clsx'

export const Select = ({
  register,
  options,
  ...rest
}: ComponentPropsWithRef<'select'> & {
  register: UseFormRegisterReturn
  options: { label: string; value: string }[]
}) => {
  return (
    <div className={clsx('relative w-full')}>
      <span
        className={
          'pointer-events-none block absolute top-1/2 right-[1rem] w-[11px] h-[11px] border-t-2 border-t-[#424242] border-r-2 border-r-[#424242] -translate-y-1/2 rotate-[135deg]'
        }
      />
      <select
        {...rest}
        className="appearance-none text-base border-gray mt-2 py-2 px-4 border rounded-sm border-solid bg-lawguebg w-full text-textblack"
        {...register}
      >
        {options.map((option) => {
          return (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          )
        })}
      </select>
    </div>
  )
}
